function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M47.3,40.8H16.7V7.4h30.5V40.8z M19.7,37.8h24.5V10.4H19.7V37.8z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M40.4,34H23.6V14.2h16.8V34z M26.6,31h10.8V17.2H26.6V31z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 19.2,
  y: 39.1,
  transform: "matrix(0.9728 0.2318 -0.2318 0.9728 12.0773 -3.4427)",
  width: 3,
  height: 21.2
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 32.7,
  y: 48.2,
  transform: "matrix(0.2316 0.9728 -0.9728 0.2316 81.6012 -3.9666)",
  width: 21.2,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 30.5,
  y: 39.3,
  width: 3,
  height: 15.2
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 16.2,
  y: 1,
  width: 31.7,
  height: 3
})))));

var SvgArtboard = function SvgArtboard(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/artboard.cc53d783.svg";
export { SvgArtboard as ReactComponent };